import { memo } from "react";
import { FILTER_LABELS } from "../utils/scoreFormatter";

/** Horizontally scrolling single-select chips; the filters come from the API. */
function FilterChips({ filters, selected, onSelect }) {
  return (
    <div className="ep-chips" role="radiogroup" aria-label="Filter products">
      {filters.map(({ code, count }) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={selected === code}
          aria-label={code === "ALL" ? "All" : `${FILTER_LABELS[code] ?? code}, ${count} products`}
          className={`ep-chip ${selected === code ? "is-selected" : ""}`}
          onClick={() => onSelect(code)}
        >
          {FILTER_LABELS[code] ?? code}
        </button>
      ))}
    </div>
  );
}

export default memo(FilterChips);
